var React = require('react');

function ToiletFemaleInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinecap":"square","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"},[React.createElement("circle",{"cx":"32","cy":"10","r":"5","key":0}),React.createElement("path",{"d":"M30.333 19h3.334a2 2 0 0 1 1.846 1.23L45 43H19l9.487-22.77A2 2 0 0 1 30.333 19zm.327 40h2.68a2 2 0 0 0 1.966-1.631L38 43H26l2.694 14.369A2 2 0 0 0 30.66 59z","key":1})]));
}

ToiletFemaleInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = ToiletFemaleInline;

ToiletFemaleInline.default = ToiletFemaleInline;
